import { render, staticRenderFns } from "./MaskSubmission.vue?vue&type=template&id=4e96a4b8&scoped=true&"
import script from "./MaskSubmission.vue?vue&type=script&lang=js&"
export * from "./MaskSubmission.vue?vue&type=script&lang=js&"
import style0 from "./MaskSubmission.vue?vue&type=style&index=0&id=4e96a4b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96a4b8",
  null
  
)

export default component.exports